import { Injectable } from '@angular/core';

import { BrandedIdType } from '../../../../customer-creation/model/branded-id-type';
import { PreregistrationData } from '../../../model/preregistration-data';

@Injectable({
  providedIn: 'root',
})
export class GcdmRequestModelMapper {
  mapToPreregistrationData(
    gcid: string,
    brand: BrandedIdType.BMW | BrandedIdType.MINI,
    language: string,
    emailAddress: string,
  ): PreregistrationData {
    return {
      brand,
      language,
      gcid,
      emailAddress,
    };
  }
}
